import React, {useState} from "react";
import FooterItem from "../components/FooterItem";
import {footerItems} from "../constants/const";
import {useNavigate} from "react-router";
import {useTonConnectUI} from "@tonconnect/ui-react";

function Footer () {
    const [activeIconName, setActiveIconName] = useState("")
    const navigate = useNavigate();

    const [tonConnectUI] = useTonConnectUI();

    const handleNavigate = (item:string, index: number) => {
        localStorage.setItem("route",item)
        switch (index) {
            case 0:
                navigate("/games")
                break;
            case 1:
                if (tonConnectUI.connected) {
                    navigate("/friends")
                } else {
                    tonConnectUI.openModal()
                        .then(() => {
                            const checkConnectionInterval = setInterval(() => {
                                if (tonConnectUI.connected === true) {
                                    navigate("/friends")
                                    clearInterval(checkConnectionInterval);
                                }
                            }, 500);
                        })
                        .catch((error) => {
                            console.log({error})
                        });
                }
                break;
            case 2:
                if (tonConnectUI.connected) {
                    navigate("/quests")
                } else {
                    tonConnectUI.openModal()
                        .then(() => {
                            const checkConnectionInterval = setInterval(() => {
                                if (tonConnectUI.connected === true) {
                                    navigate("/quests")
                                    clearInterval(checkConnectionInterval);
                                }
                            }, 500);
                        })
                        .catch((error) => {
                            console.log({error})
                        });
                }
                break;
            case 3:
                navigate("/rules-faq")
                break;
            case 4:
                if (tonConnectUI.connected) {
                    navigate("/profile")
                } else {
                    tonConnectUI.openModal()
                        .then(() => {
                            const checkConnectionInterval = setInterval(() => {
                                if (tonConnectUI.connected === true) {
                                    navigate("/profile")
                                    clearInterval(checkConnectionInterval);
                                }
                            }, 500);
                        })
                        .catch((error) => {
                            console.log({error})
                        });
                }
                break;
            default:
                navigate("*")

        }
        setActiveIconName(item)
    };

    return (
        <div className="footer">
            {footerItems.map((footerItem,index)=>{
                return (
                    <FooterItem
                        key={index}
                        name={footerItem.name}
                        icon={footerItem.icon}
                        func={()=>handleNavigate(footerItem.name, index)}
                        activeIconName={activeIconName}
                    />
                )
            })}
        </div>
    )
}

export default Footer